import React, { useEffect, useState } from 'react';
import { findDealsInInterface, rollOverDealsInInterface } from '../../../networking/NetworkingDeals';
import DatePicker from '../../shared/DatePicker';
import { formatDate } from '../../../helpers/FormatHelper';
import LoadingBox from '../../shared/LoadingBox';
import AlertBox from '../../shared/AlertBox';

const RollOverCurrencyCloudTable = ({ deals = [], startDate, calculateEndDate, verifyHoliday }) => {    

    let headers = []
    headers.push(<th style={{ cursor: 'pointer', textAlign: 'center', verticalAlign: 'center', fontSize: '0.75em' }} className="uk-table-shrink" key={1000 + 1}></th>)
    headers.push(<th style={{ cursor: 'pointer', textAlign: 'center', verticalAlign: 'center', fontSize: '0.75em' }} className="uk-table-shrink" key={1000 + 2}>Deal ID</th>)
    headers.push(<th style={{ cursor: 'pointer', textAlign: 'center', verticalAlign: 'center', fontSize: '0.75em' }} className="uk-table-shrink" key={1000 + 3}>Cover Deal ID</th>)
    headers.push(<th style={{ cursor: 'pointer', textAlign: 'center', verticalAlign: 'center', fontSize: '0.75em' }} className="uk-table-expand" key={1000 + 4}>Short Reference</th>)
    headers.push(<th style={{ cursor: 'pointer', textAlign: 'center', verticalAlign: 'center', fontSize: '0.75em' }} className="uk-table-shrink" key={1000 + 5}>New Value Date</th>)
    headers.push(<th style={{ cursor: 'pointer', textAlign: 'center', verticalAlign: 'center', fontSize: '0.75em' }} className="uk-table-expand" key={1000 + 6}>Status</th>)
    headers.push(<th style={{ cursor: 'pointer', textAlign: 'center', verticalAlign: 'center', fontSize: '0.75em' }} className="uk-table-expand" key={1000 + 7}>Currency Pair</th>)
    headers.push(<th style={{ cursor: 'pointer', textAlign: 'center', verticalAlign: 'center', fontSize: '0.75em' }} className="uk-table-expand" key={1000 + 8}>Buy Amount</th>)
    headers.push(<th style={{ cursor: 'pointer', textAlign: 'center', verticalAlign: 'center', fontSize: '0.75em' }} className="uk-table-expand" key={1000 + 9}>Sell Amount</th>)

    let rows = deals.map((x, i) => {
        return <tr key={i}  >
            <td>
                <input type="checkbox"
                    checked={x.Checked}
                    onChange={() => {
                        x.Checked = !x.Checked                        
                    }}
                />
            </td>
            <td style={{textAlign: 'center'}}>{x.DealId}</td>
            <td  style={{textAlign: 'center'}}>{x.CoverDealId}</td>
            <td  style={{textAlign: 'center'}}>{x.ShortReference}</td>
            <td>
                <DatePicker key={'dp' + x.DealNo}
                    //className={x.InvalidValueDate ? notFilledInputClass : regularInputClass}
                    value={''}
                    onDayChange={(date) => {
                        x.NewValueDate = date                        
                    }}
                    placeholder={'...'}
                    disabledDays={[0, 6]}
                    startDate={startDate}
                    endDate={calculateEndDate(startDate, x.CurrencyPair.substring(0, 3), x.CurrencyPair.substring(3, 6), 1)}
                    isHoliday={verifyHoliday}
                    readOnly={true}
                />
            </td>
            <td  style={{textAlign: 'center'}}>{x.Status}</td>
            <td  style={{textAlign: 'center'}}>{x.CurrencyPair}</td>
            <td  style={{textAlign: 'center'}}>{x.BuyAmount}</td>
            <td  style={{textAlign: 'center'}}>{x.SellAmount}</td>
        </tr>
    })


    let table =
        <div className="table-container">
            <div className="border-table" style={{ maxHeight: '50%', overflowY: 'auto', display: 'block' }}>
                <table key={'dealTableCCloud'} className="uk-table uk-table-small uk-table-hover uk-table-divider border-table uk-table-striped">
                    <thead>
                        <tr>{headers}</tr>
                    </thead>
                    <tbody>{rows}</tbody>
                </table>
            </div>
        </div>
    return table
}

const RollOverCurrencyCloud = (props) => {

    const [searchDate, setSearchDate] = useState(new Date())
    const [conversions, setConversions] = useState([])
    const [searchResults, setSearchResults] = useState('')
    const [loading, setLoading] = useState(false)
    const [alertInfo, setAlertInfo] = useState({})
    const [refresh, setRefresh] = useState(false)

    useEffect(() => {
        const load = async () => {
            let conversions = await findDealsInInterface("Currency Cloud", searchDate, searchDate, 0)
            console.log('conversions: ', conversions.CurrencyCloudConversions)
            if (Array.isArray(conversions.CurrencyCloudConversions)) {
                setConversions(conversions.CurrencyCloudConversions)
            }
            else {
                setConversions([])
            }
            setLoading(false)
        }
        setLoading(true)
        load()
    }, [searchDate, refresh])

    useEffect(() => {
        let conversionsCount = 0
        if (Array.isArray(conversions)) {
            conversionsCount = conversions.length
        }

        setSearchResults(`Currency Cloud Conversion, Search Date: ${searchDate} - Count: ${conversionsCount}`)
    }, [conversions, searchDate])

    const handleOnDayChange = (date) => {
        setSearchDate(formatDate(date))
    }

    const saveDeals = () => {
        let deals = conversions.filter(x => x.Checked)
        if (deals.length === 0) {
            setAlertInfo({ ...alertInfo, showAlert: true, alertTitle: 'Error', alertMessage: 'Must select a conversion to roll over.' })
            return
        }
        let dealsWithoutNewDate = deals.filter(x => x.NewValueDate === undefined)
        if (dealsWithoutNewDate.length > 0) {
            setAlertInfo({ ...alertInfo, showAlert: true, alertTitle: 'Error', alertMessage: 'Verify that all deals selected have a new value date' })
            return
        }
        rollOverDeals()
    }

    const saveDealsToNextBusinessDate = () => {
        let deals = conversions.filter(x => x.Checked)
        if (deals.length === 0) {
            setAlertInfo({ ...alertInfo, showAlert: true, alertTitle: 'Error', alertMessage: 'Must select a conversion to roll over.' })
            return
        }
        deals.forEach(d => { d.NewValueDate = props.nextBusinessDate })
        rollOverDeals()
    }

    const rollOverDeals = () => {
        let deals = conversions.filter(x => x.Checked)
        let applicationDate = localStorage.getItem('SystemDate');
        let userId = localStorage.getItem('UserID')
        
        const callApi = async () => {
            let response = await rollOverDealsInInterface(userId, applicationDate, props.customerId, 'Currency Cloud', deals)
            response = response || {}
            console.log(response)
            setLoading(false)

            switch (Number(response.httpStatusCode)) {
                case 200:
                    let message;
                    let title;
                    if (response.success) {
                        title = 'Success'
                        message = response.Result
                    } else {
                        title = 'Error'
                        message = response.ErrorMessage
                    }
                    setAlertInfo({ ...alertInfo, showAlert: true, alertTitle: title, alertMessage: message !== undefined && message !== '' ? message : 'All selected deals were saved successfully.' })
                    setRefresh(!refresh)
                    break
                case 409:
                    setAlertInfo({ ...alertInfo, showAlert: true, alertTitle: 'Error', alertMessage: 'Current record has been updated by other user. Please refresh the information and try again.' })
                    break
                default:
                    setAlertInfo({ ...alertInfo, showAlert: true, alertTitle: 'Error', alertMessage: 'Error saving deal(s). Please try again.' })
                    break
            }
        }
        setLoading(true)
        callApi()

    }

    return <>
        <div className="uk-grid uk-margin">
            <div className="uk-width-1-2">
                <div className="uk-grid uk-margin">
                    <div className="uk-width-1-6 uk-margin-small" style={{ alignContent: 'center' }}>
                        Date
                    </div>
                    <div className="uk-width-1-3 uk-margin-small" style={{ alignContent: 'center' }}>
                        <DatePicker className="uk-input" value={searchDate} onDayChange={handleOnDayChange} />
                    </div>
                </div>
            </div>
        </div>
        {searchResults}
        {conversions && conversions.length > 0 &&
            <RollOverCurrencyCloudTable deals={conversions} startDate={props.startDate} calculateEndDate={props.calculateEndDate} verifyHoliday={props.verifyHoliday} />}
        <hr />
        <button key="btSave" className="uk-button uk-button-default uk-button-green" type="button" onClick={saveDeals}>Save</button>
        <button key="btRolloverToNextBD" className="uk-button uk-button-default uk-button-green" type="button" onClick={saveDealsToNextBusinessDate}>Roll Over to Next Business Date</button>

        <LoadingBox loading={loading} />
        <AlertBox id="ccRolloverAlert" type="Ok" open={alertInfo.showAlert} title={alertInfo.alertTitle} message={alertInfo.alertMessage}
            okClick={() => setAlertInfo({ ...alertInfo, showAlert: false, alertTitle: '', alertMessage: '' })} onClose={() => setAlertInfo({ ...alertInfo, showAlert: false, alertTitle: '', alertMessage: '' })}
        />        
    </>
}

export default RollOverCurrencyCloud